import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FinanceiroService } from '../financeiro.service';

@Component({
  selector: 'sispac-manter-conta',
  templateUrl: './manter-conta.component.html',
  styleUrls: ['./manter-conta.component.css']
})
export class ManterContaComponent extends WebPage implements OnInit {

  public form: FormGroup;
  public contas: any[];
  public isSubmitted = false;

  constructor(messageService: MessageService,
    private fb: FormBuilder,
    private _financeiroService: FinanceiroService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService, ) {
    super(messageService);
    this.buildForm();
  }


  ngOnInit() {
    this.listaContas();
  }

  buildForm() {
    this.form = this.fb.group({
      idConta: [null],
      nome: [null, [Validators.maxLength(200), Validators.required]],
      ativo: [true]
    });
  }

  listaContas() {
    this._financeiroService.getAllContas()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.contas = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  salvar() {
    this.isSubmitted = true;
    if (this.form.valid) {

      this.isLoading = true;
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja salvar?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.isLoading = true;
          this._financeiroService.cadastrarEditar(this.form.value)
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                this.form.reset();
                this.form.patchValue({ ativo: true });
                this.isSubmitted = false;
                this.listaContas();
              },
              error => {
                this.isSubmitted = false;
                this.gerenciaErro(error);
              }
            );
        },
        reject: () => {
          this.isLoading = false;
          this.isSubmitted = false;
          this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
        }
      });

    } else {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Campos obrigatórios não preenchidos!' });
      this.isSubmitted = false;
    }
  }

  editar(id) {
    let conta =  this.contas.find(x => x.idConta === id);
    if (conta !== null) {
      this.form.patchValue({
        idConta: conta.idConta,
        nome: conta.nome,
        ativo: conta.ativo
      });
    }
  }

  excluir(id) {
    let conta =  this.contas.find(x => x.idConta === id);
    if (conta !== null) {
      conta.ativo = false;
      this.isLoading = true;
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja excluir?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.isLoading = true;
          this._financeiroService.cadastrarEditar(conta)
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                this.listaContas();
              },
              error => {
                this.gerenciaErro(error);
              }
            );
        },
        reject: () => {
          this.isLoading = false;
          this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/manter-conta/manter-conta.component.ts